import React from "react";
import { Link } from "react-router-dom";

import "../css/Footer.css";
// import logo from "../assets/images/logo.svg";

// import socials from "./assets/data/socials";

const Footer = () => {
  return (
    <footer>
      <div className="footer-top">
        {/* <img src={logo} alt="mkcy logo" className="footer-logo" /> */}
        <div className="links column-flex">
          <p className="footer-list-title">Links</p>
          <Link to="/privacypolicy" className="footer-link">
            Privacy Policy
          </Link>
          <Link to="/tnc" className="footer-link">
            Terms {"&"} Conditions
          </Link>
        </div>
      </div>
      <div className="footer-bottom">
        <p className="footer-bottom-text">
          COPYRIGHT © {new Date().getFullYear()}<br/> MKCY INDUSTRIAL SOLUTIONS PVT. LTD
 - ALL
          RIGHTS RESERVED
        </p>
        <p className="footer-bottom-text light">
          591 Salesh Farm Colony, Pilkhuwa, Hapur, Uttar Pradesh, India, 245304
        </p>
      </div>
    </footer>
  );
};

export default Footer;
